module.exports = __webpack_public_path__ + "img/plats.5d4c1d40.svg";